<template>
  <div class="popup-main">
    <el-dialog
      title="价格计算"
      width="1400px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div class="mu-ban-category">
          <!-- 类目 -->
          <div>商品类目：</div>
          <b-goods-texture :data.sync="categoryTextureData" />
          <!-- 模板表格 -->
          <template v-if="isShowMuBan">
            <div class="m-l-10">模板名称：</div>
            <el-select v-model="detailId" size="mini" filterable>
              <el-option
                v-for="item in mubanList"
                :key="item.val"
                :label="item.key"
                :value="item.val"
              />
            </el-select>
          </template>
        </div>

        <!-- 计算价格 -->
        <div class="table-bottom m-t-10">
          <div class="verify-cont">
            <div v-if="false" class="verify-title">计算示例:</div>
            <div class="m-t-10">
              <e-form ref="refVerifyForm" :column="verifyFormColumn" :data.sync="verifyData" />
            </div>
            <el-button
              v-if="verifyFormColumn.length"
              type="warning"
              size="mini"
              @click="actionVerify"
            >
              开始计算
            </el-button>
          </div>
        </div>
        <div class="verify-table">
          <vxe-grid
            :height="500"
            :toolbar-config="tableConfig.toolbarConfig"
            :row-config="tableConfig.rowConfig"
            :keyboard-config="tableConfig.keyboardConfig"
            :merge-cells="verifyMergeCell"
            :columns="verifyTableColumn"
            :data="effectDanWeiList"
          >
            <!-- slot_default -->
            <template #default_dan_wei_name="{ row }">
              <div class="flex flex-y-center flex-x-between">
                <span>{{ row.dan_wei_name }}</span>
                <span v-if="row.is_mo_ren_dan_wei" class="unit-sub-tag">默认单位</span>
              </div>
            </template>
            <template #default_verify_unit_val="{ row }">
              <div class="flex flex-y-center flex-x-between">
                <span class="flex-1 m-r-5">
                  {{ $util.getNumberFullString(row.verify_unit_val) }}
                </span>
                <span class="c-gray-light">{{ row.dan_wei_name }}</span>
              </div>
            </template>
            <template #default_verify_price_val="{ row }">
              <div class="flex flex-y-center flex-x-between">
                <span class="flex-1 m-r-5">
                  {{ $util.getNumberFullString(row.verify_price_val) }}
                </span>
                <span class="c-gray-light">{{ `元/${row.dan_wei_name}` }}</span>
              </div>
            </template>
          </vxe-grid>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="popupCancel">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,

      // 类目
      categoryTextureData: {},

      // 模板
      mubanList: [],
      filterData: {},
      detailId: '',
      timer: null,
      headerFilterUrl: '/admin/gcvip/muBan/searchHeard',

      // 价格计算
      verifyFormColumn: [],
      defaultVerifyFormColumn: [
        {
          type: 'text',
          field: 'mo_ren_dan_wei_zu',
          title: '默认单位',
          disabled: true
        },
        {
          type: 'text',
          field: 'gui_ge_shi_li',
          title: '规格',
          required: true,
          placeholder: ''
        },
        {
          // 不显示
          // type: 'text',
          field: 'ji_jia_shi_li',
          title: '基价'
          // required: true,
          // placeholder: '自动计算',
          // disabled: true
        }
      ],
      selfData: {
        mo_ren_dan_wei_zu: '',
        ji_chu_jia_ge: '',
        ji_chu_jia_ge_list: [
          {
            tiao_zheng_key: '',
            tiao_zheng_scope_start: '',
            tiao_zheng_scope_end: '',
            tiao_zheng_type: '',
            tiao_zheng_val: ''
          }
        ],
        gui_ge_list: [],
        dan_wei_zu_list: []
      },
      verifyData: {
        mo_ren_dan_wei_zu: '',
        gui_ge_shi_li: '',
        ji_jia_shi_li: '',
        chan_liang_shi_li: ''
      },
      verifyTableColumn: [
        {
          title: '单位分组',
          field: 'dan_wei_zu_name',
          isMerge: true
        },
        {
          title: '单位',
          field: 'dan_wei_name',
          slots: { default: 'default_dan_wei_name' }
        },
        {
          title: '单位参数计算',
          field: 'verify_unit_val',
          slots: { default: 'default_verify_unit_val' }
        },
        {
          title: '单价参数计算',
          field: 'verify_price_val',
          slots: { default: 'default_verify_price_val' }
        }
      ],
      verifyMergeCell: [],
      danWeiZuList: []
    }
  },
  computed: {
    // 类目选中字符串
    categoryActiveStr() {
      let result = ''
      let listName = this.categoryTextureData.category_list.map((item) => {
        return item.name
      }) // 类目
      if (this.categoryTextureData.texture_data.key) {
        listName.push(this.categoryTextureData.texture_data.key) // 材质
      }

      result = listName.join('/')
      return result // 类目材质拼接成字符串
    },
    // 类目类型
    activeCategoryType() {
      let result = ''
      if (this.categoryTextureData && this.categoryTextureData.category_list) {
        let len = this.categoryTextureData.category_list.length
        if (len) result = this.categoryTextureData.category_list[len - 1].lei_mu_lei_xing
      }
      return result
    },
    // 是否显示模版
    isShowMuBan() {
      let result = this.activeCategoryType === '原料' || this.activeCategoryType === '加工'
      return result
    },
    // 表格配置合并
    tableConfig() {
      let obj = {}
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    // 规格列表
    guigeList() {
      let result = this.selfData.gui_ge_list.map((item) => {
        let obj = {
          key: item,
          val: item
        }
        return obj
      })
      return result
    },
    // 有效的单位列表
    effectDanWeiList() {
      let result = []
      let isTimeMoRenDanWei = this.danWeiZuList.some((item) => {
        return item.dan_wei_zu_name === '时间' && item.is_mo_ren_dan_wei
      })
      this.danWeiZuList.forEach((item) => {
        if (item.dan_wei_zu_name === '时间') {
          if (isTimeMoRenDanWei) result.push(item)
        } else {
          result.push(item)
        }
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    // 类目材质数据
    categoryTextureData: {
      handler(val) {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.filterData = {
            lei_mu_name: this.categoryActiveStr
          }
          this.selfData.mi_du_shi_li = val.texture_data.val
          this.getMubanListData()
          this.timer = null
        }, 500)
      },
      deep: true,
      immediate: true
    },
    'selfData.dan_wei_zu_list': {
      handler(val) {
        this.danWeiZuList = []
        val.forEach((itemSt) => {
          itemSt.dan_wei_list.forEach((itemNd) => {
            let obj = this.$util.deepCopy(itemNd)
            let result = {
              dan_wei_zu_name: itemSt.dan_wei_zu_name,
              dan_wei_zu_id: itemSt.id,
              ...obj
            }
            this.danWeiZuList.push(result)
          })
        })

        this.verifyMergeCell = this.$tool.getMergeCellConfigList(
          this.effectDanWeiList,
          this.verifyTableColumn,
          'dan_wei_zu_name'
        )
      },
      deep: true,
      immediate: true
    },
    detailId(val) {
      if (val) this.itemChoose()
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 获取模板列表数据
    getMubanListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          filterData: this.filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.mu_ban_ming_cheng,
                val: item.id
              }
            })
            this.mubanList = result
            if (this.mubanList.length) {
              this.detailId = this.mubanList[0].val
            } else {
              this.$message.error('该类目无商品模板')
              this.detailId = ''
            }
          }
        })
        .catch(() => {})
    },
    // 项-选择
    async itemChoose() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/muBan/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.data
          result.dan_wei_zu_list.forEach((itemSt) => {
            itemSt.dan_wei_list.forEach((itemNd) => {
              itemNd.verify_unit_val = ''
              itemNd.verify_price_val = ''
            })
          })
          this.selfData = result
        }
      })

      let verifyData = {
        mo_ren_dan_wei_zu: this.$tool.getDanWei(this.selfData.mo_ren_dan_wei_zu),
        gui_ge_shi_li: this.selfData.gui_ge_shi_li,
        ji_chu_jia_ge: this.selfData.ji_chu_jia_ge,
        ji_chu_chan_liang: this.selfData.ji_chu_chan_liang,
        ji_jia_shi_li: '',
        chan_liang_shi_li: ''
      }
      let verifyFormColumn = []

      this.selfData.fu_jia_can_shu_list.forEach((item, index) => {
        let fieldName = `fu_jia_can_shu_${index}`
        verifyData[fieldName] = this.selfData.fu_jia_can_shu_shi_li[index] || ''
        let obj = {
          type: 'text',
          field: fieldName,
          title: item.name,
          width: '189px',
          fnChange: () => {
            this.setFuJiaCanShuShiLi()
          }
        }
        verifyFormColumn.push(obj)
      })
      this.verifyData = verifyData

      this.verifyFormColumn = this.$util.deepCopy(this.defaultVerifyFormColumn)
      this.verifyFormColumn.forEach((item) => {
        if (item.title === '规格')
          item.placeholder = `${this.selfData.gui_ge_list.join('*')}(单位mm)`
      })
      this.verifyFormColumn = [...this.verifyFormColumn, ...verifyFormColumn]
      // 默认单位的单位分组为时间，才显示产量产量示例
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        itemSt.dan_wei_list.forEach((itemNd) => {
          let hasDefaultTimeJiaGong = itemNd.is_mo_ren_dan_wei && itemSt.dan_wei_zu_name === '时间'
          if (hasDefaultTimeJiaGong) {
            this.verifyFormColumn.push({
              type: 'text',
              field: 'chan_liang_shi_li',
              title: '产量示例',
              required: true,
              placeholder: '自动计算',
              disabled: true
            })
          }
        })
      })

      this.actionVerify()
    },
    // 设置附加参数示例
    setFuJiaCanShuShiLi() {
      this.selfData.fu_jia_can_shu_shi_li = this.selfData.fu_jia_can_shu_list.map((item, index) => {
        let fieldName = `fu_jia_can_shu_${index}`
        let result = this.verifyData[fieldName]
        return result
      })
    },
    // 开始计算
    actionVerify() {
      // 校验必填项------------------------------------------
      if (!this.mubanList.length) {
        this.$message.error('该类目无商品模板')
      }

      let requiredList = []
      if (!this.verifyData.gui_ge_shi_li) requiredList.push('规格示例')
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        itemSt.gong_shi_list.forEach((itemNd) => {
          this.selfData.fu_jia_can_shu_list.forEach((itemRd, indexRd) => {
            if (itemRd.name === itemNd) {
              let isEmpty = !this.selfData.fu_jia_can_shu_shi_li[indexRd]
              let isNotRepeat = requiredList.every((itemTh) => itemTh !== itemNd)
              if (isEmpty && isNotRepeat) requiredList.push(itemNd)
            }
          })
        })
      })
      if (requiredList.length) {
        this.$message.error(`请输入${requiredList[0]}`)
        return
      }

      // 对象参数------------------------------------------
      let objCs = {
        密度: this.selfData.mi_du_shi_li
      }
      let guigeList = this.verifyData.gui_ge_shi_li.split('*')
      this.selfData.gui_ge_list.forEach((item, index) => (objCs[item] = guigeList[index]))
      this.selfData.fu_jia_can_shu_list.forEach(
        (item, index) => (objCs[item.name] = this.selfData.fu_jia_can_shu_shi_li[index])
      )

      // 基础产量示例浮动处理------------------------------------------
      let resultChanLiangShuzhi = 0
      let resultChanLiangBili = 0
      let effectJiChuChanLiangList = []
      this.selfData.ji_chu_chan_liang_list.forEach((itemSt, indexSt) => {
        itemSt.forEach((itemNd) => {
          // 获取有效的浮动列表
          let resA =
            itemNd.tiao_zheng_key_list.length && itemNd.tiao_zheng_type && itemNd.tiao_zheng_val
          let resB = false
          if (indexSt) {
            resB = !!itemNd.tiao_zheng_scope_val
          } else {
            resB = itemNd.tiao_zheng_scope_start || itemNd.tiao_zheng_scope_end
          }
          if (resA && resB) {
            effectJiChuChanLiangList.push({ ...itemNd, type: indexSt })
          }
        })
      })
      effectJiChuChanLiangList.forEach((item) => {
        let resultComparePass = false
        // 0：参数范围
        if (item.type === 0) {
          let key = item.tiao_zheng_key_list[0]
          let tiaoZhengObj = {
            key: key,
            val: objCs[key]
          }
          let resultCompareS = Number(tiaoZhengObj.val) >= Number(item.tiao_zheng_scope_start) // 对比开始值
          let resultCompareE = Number(tiaoZhengObj.val) <= Number(item.tiao_zheng_scope_end) // 对比结束值
          if (item.tiao_zheng_scope_start && !item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS
          }
          if (!item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareE
          }
          if (item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS && resultCompareE
          }
        }
        // 1：参数匹配
        if (item.type === 1) {
          let symbolStr = this.$constant.pipeiSymbolList[0]
          this.$constant.pipeiSymbolList.forEach((itemSymbol) => {
            if (item.tiao_zheng_scope_val.includes(itemSymbol)) symbolStr = itemSymbol
          })
          let piPeiList = item.tiao_zheng_scope_val.split(symbolStr)
          let tiaoZhengList = item.tiao_zheng_key_list.map((itemKey) => objCs[itemKey])
          let sortPiPeiList = piPeiList.sort((a, b) => a - b)
          let sortTiaoZhengList = tiaoZhengList.sort((a, b) => a - b)
          resultComparePass = sortPiPeiList.join(',') === sortTiaoZhengList.join(',')
        }

        if (!resultComparePass) return
        if (item.tiao_zheng_type === '0') {
          resultChanLiangShuzhi = this.$XEUtils.add(resultChanLiangShuzhi, item.tiao_zheng_val) // 上调数值
        }
        if (item.tiao_zheng_type === '1') {
          resultChanLiangShuzhi = this.$XEUtils.subtract(resultChanLiangShuzhi, item.tiao_zheng_val) // 下调数值
        }
        if (item.tiao_zheng_type === '2') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_chan_liang,
            item.tiao_zheng_val / 100
          )
          resultChanLiangBili = this.$XEUtils.add(resultChanLiangBili, result) // 上调比例
        }
        if (item.tiao_zheng_type === '3') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_chan_liang,
            item.tiao_zheng_val / 100
          )
          resultChanLiangBili = this.$XEUtils.subtract(resultChanLiangBili, result) // 下调比例
        }
      })
      this.verifyData.chan_liang_shi_li = this.selfData.ji_chu_chan_liang // 产量示例
      this.verifyData.chan_liang_shi_li = this.$XEUtils.add(
        this.verifyData.chan_liang_shi_li,
        resultChanLiangShuzhi
      ) // 加数值
      this.verifyData.chan_liang_shi_li = this.$XEUtils.add(
        this.verifyData.chan_liang_shi_li,
        resultChanLiangBili
      ) // 加比例

      // 基础价格示例浮动处理------------------------------------------
      let resultJiJiaShuzhi = 0
      let resultJiJiaBili = 0
      let effectJiChuJiaGeList = []
      this.selfData.ji_chu_jia_ge_list.forEach((itemSt, indexSt) => {
        itemSt.forEach((itemNd) => {
          // 获取有效的浮动列表
          let resA =
            itemNd.tiao_zheng_key_list.length && itemNd.tiao_zheng_type && itemNd.tiao_zheng_val
          let resB = false
          if (indexSt) {
            resB = !!itemNd.tiao_zheng_scope_val
          } else {
            resB = itemNd.tiao_zheng_scope_start || itemNd.tiao_zheng_scope_end
          }
          if (resA && resB) {
            effectJiChuJiaGeList.push({ ...itemNd, type: indexSt })
          }
        })
      })
      effectJiChuJiaGeList.forEach((item) => {
        let resultComparePass = false
        // 0：参数范围
        if (item.type === 0) {
          let key = item.tiao_zheng_key_list[0]
          let tiaoZhengObj = {
            key: key,
            val: objCs[key]
          }
          let resultCompareS = Number(tiaoZhengObj.val) >= Number(item.tiao_zheng_scope_start) // 对比开始值
          let resultCompareE = Number(tiaoZhengObj.val) <= Number(item.tiao_zheng_scope_end) // 对比结束值
          if (item.tiao_zheng_scope_start && !item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS
          }
          if (!item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareE
          }
          if (item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS && resultCompareE
          }
        }
        // 1：参数匹配
        if (item.type === 1) {
          let symbolStr = this.$constant.pipeiSymbolList[0]
          this.$constant.pipeiSymbolList.forEach((itemSymbol) => {
            if (item.tiao_zheng_scope_val.includes(itemSymbol)) symbolStr = itemSymbol
          })
          let piPeiList = item.tiao_zheng_scope_val.split(symbolStr)
          let tiaoZhengList = item.tiao_zheng_key_list.map((itemKey) => objCs[itemKey])
          let sortPiPeiList = piPeiList.sort((a, b) => a - b)
          let sortTiaoZhengList = tiaoZhengList.sort((a, b) => a - b)
          resultComparePass = sortPiPeiList.join(',') === sortTiaoZhengList.join(',')
        }

        if (!resultComparePass) return
        if (item.tiao_zheng_type === '0') {
          resultJiJiaShuzhi = this.$XEUtils.add(resultJiJiaShuzhi, item.tiao_zheng_val) // 上调数值
        }
        if (item.tiao_zheng_type === '1') {
          resultJiJiaShuzhi = this.$XEUtils.subtract(resultJiJiaShuzhi, item.tiao_zheng_val) // 下调数值
        }
        if (item.tiao_zheng_type === '2') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_jia_ge,
            item.tiao_zheng_val / 100
          )
          resultJiJiaBili = this.$XEUtils.add(resultJiJiaBili, result) // 上调比例
        }
        if (item.tiao_zheng_type === '3') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_jia_ge,
            item.tiao_zheng_val / 100
          )
          resultJiJiaBili = this.$XEUtils.subtract(resultJiJiaBili, result) // 下调比例
        }
      })
      this.verifyData.ji_jia_shi_li = this.selfData.ji_chu_jia_ge // 基价示例
      this.verifyData.ji_jia_shi_li = this.$XEUtils.add(
        this.verifyData.ji_jia_shi_li,
        resultJiJiaShuzhi
      ) // 加数值
      this.verifyData.ji_jia_shi_li = this.$XEUtils.add(
        this.verifyData.ji_jia_shi_li,
        resultJiJiaBili
      ) // 加比例

      // 单位组-单位参数计算------------------------------------------
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        let main_verify_unit_val = '' // 主计量-单位参数计算
        // 主计量-单位参数计算
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (itemNd.is_zhu_ji_liang) {
            let result = ''
            if (itemSt.dan_wei_zu_name === '时间') {
              result = this.$XEUtils.divide(1, this.verifyData.chan_liang_shi_li) // 使用：1/产量示例
            } else {
              result = this.$tool.gongShiResult(itemSt.gong_shi_list, objCs) // 使用：公式计算
            }
            itemNd.verify_unit_val = result
            main_verify_unit_val = result
          }
        })
        // 辅计量-单位参数计算
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (!itemNd.is_zhu_ji_liang) {
            itemNd.verify_unit_val = this.$XEUtils.multiply(
              main_verify_unit_val,
              itemNd.zhuan_huan_zhi
            )
          }
        })
      })

      // 单位组-单价参数校验------------------------------------------
      let default_guige_price_val = ''
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        // 默认单位-单价
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (itemNd.is_mo_ren_dan_wei) {
            default_guige_price_val = this.$XEUtils.multiply(
              itemNd.verify_unit_val,
              this.verifyData.ji_jia_shi_li
            )
          }
        })
      })
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        // 所有单位-单价
        itemSt.dan_wei_list.forEach((itemNd) => {
          itemNd.verify_price_val = this.$XEUtils.divide(
            default_guige_price_val,
            itemNd.verify_unit_val
          )
        })
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .mu-ban-category {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid @colorGrayE;
  }

  .table-bottom {
    display: flex;
    align-items: center;
    padding: 5px;
    border: @borderTable;
    .verify-cont {
      display: flex;
      align-items: center;
      height: 28px;
      overflow: hidden;
      .verify-title {
        padding: 0 10px;
        margin-right: 10px;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
        color: @colorOrangeYellow;
        background: @colorOrangeYellow20;
        border-radius: 3px;
      }
      /deep/ .el-button {
        height: 28px;
        line-height: 28px;
        padding: 0 10px;
      }
    }
  }

  .verify-table {
    margin-top: 10px;
    /deep/ .vxe-table--render-default.size--mini .vxe-body--column:not(.col--ellipsis) {
      height: 18px;
    }
  }

  .unit-sub-tag {
    color: @colorWhite;
    padding: 0 2px;
    margin-right: 5px;
    border-radius: 2px;
    background: @colorGreen;
  }
}
</style>
